import React, { Component } from "react";
export class ColorFormatter extends Component {
    render() {
      var value = this.props.value === undefined ? null : this.props.value;
      var toRed = false;
      if (!(value === null)) {
        toRed = value === "N" || value === "Out of Tolerance" ? true : false;
      }
      return toRed === true ? <span style={{color:"red"}}>{value}</span> : <span>{value}</span>;
    }
  }